import { gql } from '@apollo/client';

import { PageReplyFragment } from '@modules/layout/graphql';

export const SubjectCollectionFragment = gql`
    fragment SubjectCollection on OLSubjectCollection {
        items {
            id
            name
            text
            courseId
            createdAt
            sort
            test {
                questionsCount
                duration
            }
            testEnabled
            lectures {
                id
                docs {
                    name
                }
            }
            videos {
                name
            }
            userTest {
                id
                resultSuccess
            }
            testQuestions {
                id
            }
        }
        page {
            ...PageReply
        }
    }
    ${PageReplyFragment}
`;
